module.exports = __webpack_public_path__ + "static/img/wenhuayishu-3.fd09eb1a.svg";